// eslint-disable-next-line
import I18n from '/src/utils/translations.js'

const items = () => {
  return [
    {
      name: 'requests',
      title: I18n.t('top_menu.requests')
    },
    {
      name: 'scopes',
      title: I18n.t('top_menu.scoping')
    },
    {
      name: 'plannings',
      title: I18n.t('top_menu.planning')
    },
    {
      name: 'performances',
      title: I18n.t('top_menu.performance')
    },
    {
      name: 'inspections',
      title: I18n.t('top_menu.inspections')
    }
  ]
}

export default items
